import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import MuiExpansionPanel from "@material-ui/core/ExpansionPanel";
import MuiExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import MuiExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";

import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

import EditableList from "./EditableList";

const useStyles = makeStyles({
  content: {
    "& .MuiFormControl-root": {
      marginTop: "10px",
      width: "100%"
    },
    "& > span": {
      display: "block",
      fontSize: "14px",
      lineHeight: "18px",
      marginBottom: "16px"
    }
  }
});

const ExpansionPanel = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0
    },
    "&:before": {
      display: "none"
    },
    "&$expanded": {
      margin: "auto"
    }
  },
  expanded: {}
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    backgroundColor: "#F2F2F2",
    border: "1px solid #CACCD1",
    marginBottom: -1,
    minHeight: 40,
    margin: 0,
    padding: 0,
    "& .MuiExpansionPanelSummary-content": {
      margin: 0,
      "& > p": {
        fontSize: 14,
        color: "#00334E",
        marginLeft: "10px",
        marginTop: "3px",
        textTransform: "uppercase"
      },
      "& svg": {
        marginLeft: "5px",
        marginBottom: "5px",
        fill: "#00334E"
      }
    },
    "&$expanded": {
      minHeight: 40
    }
  },
  content: {
    "&$expanded": {}
  },
  expanded: {}
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column"
  }
}))(MuiExpansionPanelDetails);

export default function ModuleRequirements({ title, matchId, moduleAbility }) {
  const { content } = useStyles();
  const [expanded, setExpanded] = React.useState("panel1");

  const handleChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const dataKnows = moduleAbility.filter(items => items.typeId === 1);
  const dataCan = moduleAbility.filter(items => items.typeId === 2);
  const dataOwn = moduleAbility.filter(items => items.typeId === 3);

  return (
    <div className={content}>
      <span>{title}</span>
      <ExpansionPanel
        square
        expanded={expanded === `panel1`}
        onChange={handleChange(`panel1`)}
      >
        <ExpansionPanelSummary>
          {expanded === `panel1` ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
          <Typography>Знать</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <EditableList items={dataKnows} typeId={1} matchId={matchId} />
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <ExpansionPanel
        square
        expanded={expanded === `panel2`}
        onChange={handleChange(`panel2`)}
      >
        <ExpansionPanelSummary>
          {expanded === `panel2` ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
          <Typography>Уметь</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <EditableList items={dataCan} typeId={2} matchId={matchId} />
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <ExpansionPanel
        square
        expanded={expanded === `panel3`}
        onChange={handleChange(`panel3`)}
      >
        <ExpansionPanelSummary>
          {expanded === `panel3` ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
          <Typography>Владеть трудовыми действиями</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <EditableList items={dataOwn} typeId={3} matchId={matchId} />
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  );
}
